// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2p1c3","inputWrap":"styles_inputWrap__1vdKv","input":"styles_input__2O6tO"};